import { ref, readonly, watch } from 'vue'
// TODO: 12/20 无自定义主题预览
// import { usePreview } from '@/views/home/preview/hooks'
import usePreference from '@teams/common/hooks/usePreference'

const useViewConfig = (() => {
  const preference = usePreference({ defaultClient: 'pc' })
  const useAsideNav = ref(false) // 是否使用左侧导航栏
  const shouldStickyGroupPanel = ref(false) // 是否固定左侧团队管理面板
  const showCustomPanel = ref(false) // 是否展示用户定制面板
  const showFloatBall = ref(false) // 是否展示用户定制悬浮条（球）
  // TODO: 12/20 无自定义主题预览
  // const preview = usePreview()

  const setUseAsideNav = (val: boolean) => {
    useAsideNav.value = val
  }

  const toggleUseAsideNav = () => {
    setUseAsideNav(!useAsideNav.value)
  }

  const setStickyGroupPanel = (val: boolean) => {
    shouldStickyGroupPanel.value = val
  }

  const toggleStickyGroupPanel = () => {
    setStickyGroupPanel(!shouldStickyGroupPanel.value)
  }

  const setCustomPanel = (val: boolean) => {
    showCustomPanel.value = val
    // TODO: 12/20 无自定义主题预览
    // preview.setInPreview(val)
  }
  const toggleCustomPanel = () => {
    if (showCustomPanel.value === true) {
      return true
    }
    setCustomPanel(true)
  }
  const closeCustomPanel = () => {
    setCustomPanel(false)
  }
  const setFloatBall = (val: boolean) => {
    showFloatBall.value = val
  }
  watch([() => preference.current.layout.navBarPosition], () => {
    setUseAsideNav(preference.current.layout.navBarPosition === 'float')
  })

  return () => ({
    useAsideNav: readonly(useAsideNav),
    shouldStickyGroupPanel: readonly(shouldStickyGroupPanel),
    showCustomPanel: readonly(showCustomPanel),
    showFloatBall: readonly(showFloatBall),
    setUseAsideNav,
    toggleUseAsideNav,
    setStickyGroupPanel,
    toggleStickyGroupPanel,
    setCustomPanel,
    toggleCustomPanel,
    closeCustomPanel,
    setFloatBall
  })
})()

export default useViewConfig
